import { Footer2 } from '@bm-js/atlascloud-ui'
import Footer1 from '../Footer1'
import { useCustomer, useEditorData } from '../../utils/hooks'
import LinkComponent from '../LinkComponent'

const FooterSwitcher = () => {
  const { workingConfig } = useEditorData()
  const customer = useCustomer()
  switch (workingConfig.footerType) {
    case 'footer1':
      return (
        <Footer1
          websiteConfig={workingConfig}
          optOutFromAtlasCloudAttribution={!!customer?.optOutFromAtlasCloudAttribution}
        />
      )

    case 'footer2':
      return (
        <Footer2
          LinkComponent={LinkComponent}
          contactInfo={workingConfig.contactInfo}
          footerImage={workingConfig.footerImage}
          footerText={workingConfig.footerText}
          socialMedia={workingConfig.socialMedia}
        />
      )
    default:
      return null
  }
}

export default FooterSwitcher
